export default __webpack_public_path__ + "static/media/phone.03b6e7fc.webp";